/**
 * useAuth.js
 * Vereinfachter Zugriff auf Dynamic Auth-State
 *
 * Exportiert den passenden Hook basierend auf Auth-Konfiguration.
 */
import { isAuthEnabled } from './DynamicProvider';

// Fallback für deaktivierte Auth
const AUTH_DISABLED_FALLBACK = {
  isLoggedIn: true, // Treat as logged in when auth disabled
  isLoading: false,
  user: null,
  openLogin: () => console.warn('[Auth] Auth ist deaktiviert'),
  logout: () => console.warn('[Auth] Auth ist deaktiviert'),
  getAuthToken: null,
  wallet: null,
};

function useAuthDisabled() {
  return AUTH_DISABLED_FALLBACK;
}

// Conditional export based on auth status
export let useAuth;

if (isAuthEnabled) {
  // Dynamisch importieren nur wenn Auth aktiviert
  const { useAuthEnabled } = require('./useAuthEnabled');
  useAuth = useAuthEnabled;
} else {
  useAuth = useAuthDisabled;
}
